import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Divider } from "@mui/material";
import Label from "../../Label/Label";

// Function to format the value
const formatValue = (value) => {
  if (Array.isArray(value)) {
    return (
      <>
        {value.map((item, index) => (
          <div key={index}>
            <div style={{ display: "flex" }}>
              <Label text={index + 1} fontWeight={600} />
              <Label text={":"} padding={"0px 5px"} />
              <Label text={item} />
            </div>
            {index + 1 !== value.length && (
              <Divider variant="middle" style={{ margin: "10px" }} />
            )}
          </div>
        ))}
      </>
    );
  } else if (typeof value === "object" && value !== null) {
    return (
      <>
        <div>
          {Object.entries(value).map(([key, val], index) => (
            <div key={index}>
              <div style={{ display: "flex" }}>
                <Label text={key} />
                <Label text={":"} padding={"0px 5px"} />
                <Label text={val} />
                <Divider variant="middle" />
              </div>
            </div>
          ))}
        </div>
        <Divider style={{ margin: "10px 0px" }} />
      </>
    );
  } else {
    return value;
  }
};

const formatKey = (key) => {
  // Replace underscore with space and convert to camel case
  if (key.includes("_")) {
    return key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  } else {
    // Convert to camel case for single-word keys
    return key.replace(/^\w/, (c) => c.toUpperCase());
  }
};

export default function BasicModal({ isOpenModal, handleClose, data }) {
  return (
    <div>
      <Dialog
        open={isOpenModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle id="alert-dialog-title">
          <Label text="Document Detail" fontWeight={"600"} fontSize={"18px"} />{" "}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ margin: "10px 20px 20px 20px" }}>
          {Object.entries(data).map(([key, value], index) => (
            <div key={key}>
              <Label text={formatKey(key)} fontWeight="600" />
              {/* <Typography variant="body1" >{JSON.stringify(value)}</Typography> */}
              {formatValue(value)}

              {index + 1 !== Object.entries(data).length && (
                <Divider style={{ margin: "10px 0px" }} />
              )}
            </div>
          ))}
        </DialogContent>
      </Dialog>
    </div>
  );
}
